import script from "./AdminFormElementMulti.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminFormElementMulti.vue?vue&type=script&setup=true&lang=js"

import "./AdminFormElementMulti.vue?vue&type=style&index=0&id=5222dc1d&lang=scss"

const __exports__ = script;

export default __exports__